export default __webpack_public_path__ + "static/media/question_mark.a72a11bd.svg";